<mat-selection-list #matSelection role="list" class="list-jornadas" (selectionChange)="getSelected($event)"
  [compareWith]="compareObjects" [formControl]="control">
  <mat-list-option #matOptions *ngFor="let item of result" [value]="item">
    <mat-icon mat-list-icon (click)="openEdit(item)">edit</mat-icon>
    {{item.tipo }}
  </mat-list-option>
</mat-selection-list>